import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useExclusivityRetailerNodes } from "./nodes/useExclusivityRetailerNodes";
import { useHowFaireWorksRetailerNodes } from "./nodes/useHowFaireWorksRetailerNodes";
import { useInsiderMembershipRetailerNodes } from "./nodes/useInsiderMembershipRetailerNodes";
import { useInvoicesAndPaymentsRetailerNodes } from "./nodes/useInvoicesAndPaymentsRetailerNodes";
import { useMyAccountRetailerNodes } from "./nodes/useMyAccountRetailerNodes";
import { useOrdersAndShippingRetailerNodes } from "./nodes/useOrdersAndShippingRetailerNodes";
import { useReferralsRetailerNodes } from "./nodes/useReferralsRetailerNodes";
export var useRetailerNodesV1 = function useRetailerNodesV1() {
  var ORDERS_AND_SHIPPING_NODES = useOrdersAndShippingRetailerNodes();
  var MY_ACCOUNT_NODES = useMyAccountRetailerNodes();
  var INVOICES_AND_PAYMENTS_NODES = useInvoicesAndPaymentsRetailerNodes();
  var INSIDER_MEMBERSHIP_NODES = useInsiderMembershipRetailerNodes();
  var EXCLUSIVITY_NODES = useExclusivityRetailerNodes();
  var REFERRALS_NODES = useReferralsRetailerNodes();
  var HOW_FAIRE_WORKS_NODES = useHowFaireWorksRetailerNodes();
  return _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({
    Root: {
      id: "Root",
      children: ["OrdersAndShipping", "MyAccount", "InvoicesAndPayments", "InsiderMembership", "Exclusivity", "Referrals", "HowFaireWorks"],
      level: 0
    }
  }, ORDERS_AND_SHIPPING_NODES), MY_ACCOUNT_NODES), INVOICES_AND_PAYMENTS_NODES), INSIDER_MEMBERSHIP_NODES), EXCLUSIVITY_NODES), REFERRALS_NODES), HOW_FAIRE_WORKS_NODES);
};